import React from 'react';
import { Outlet } from 'react-router-dom';
import Bdashboard from './Bdashboard';

const BrokerLayout = () => {
  return (
    <div className="broker-layout" style={{ display: 'flex', alignItems: 'flex-start' }}>
      <Bdashboard />
      <main style={{ flexGrow: 1 }}>
        <Outlet />
      </main>
    </div>
  );
};

export default BrokerLayout;
